import { Box, Divider } from '@chakra-ui/react';

export const StandardizingMediaDataContent = () => (
  <Box>
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Introduction: Clean Data = Clear Insight
      </Box>
      <Box mb={4}>
        In a multi-channel world, media data comes in different shapes,
        frequencies, and currencies. Traditional MMM setup can drag on for weeks
        in data prep. That&apos;s where Yapamar shines; it wrangles blended ad
        data, online and offline for you, ensuring your model starts with
        clarity, not confusion.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 1: Unified Data Model, No Headaches
      </Box>
      <Box mb={4}>
        Instead of wrestling with disjointed exports (spend, conversions,
        impressions, CRM integrations), Yapamar normalizes everything
        automatically. You&apos;ll provide GA4 or CRM data and other ad platform
        credentials and upload the rest of your data via our upload service.
      </Box>
      <Box mb={4}>
        Yapamar has in-house connectors to acquire data from your &ldquo;Google
        Ads&rdquo;, &ldquo;Facebook&rdquo;, &ldquo;TikTok&rdquo;, and
        &ldquo;Snapchat&rdquo; campaigns, and along with your TV, radio, and OOH
        campaign data Yapamar unifies everything into a single coherent data
        model.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 2: Auto-Normalization, with Transparency
      </Box>
      <Box mb={4}>
        Ever spent hours aligning marketing data from Facebook, TikTok,
        Snapchat, and Google Ads?
      </Box>
      <Box mb={4}>
        With Yapamar, that hassle is a thing of the past. Beneath the surface,
        the platform normalizes data to consistent naming, dates, and metrics,
        so your MMM sees one unified, structured dataset. You can also
        participate in the normalization and naming consistency with our
        &ldquo;Campaign Matching&rdquo; view.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 3: Blend Online + Offline with Ease
      </Box>
      <Box mb={4}>
        Whether it&apos;s TV, radio, OOH, or digital, Yapamar integrates all
        into the same modeling pipeline. No manual joins or extra SQL, just one
        clean dataset that supports better model accuracy and faster iteration.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Step 4: Validated Before Modeling
      </Box>
      <Box mb={4}>
        Yapamar applies sanity checks before modeling: Does total spend line up?
        Are conversions consistent? If something&apos;s off, you&apos;re flagged
        immediately, so you can fix data upstream, not after the model runs.
      </Box>
      <Box mb={4}>
        Validation is also provided via the &ldquo;Data Upload&rdquo; service to
        ensure that even manually uploaded data is consistent and conforms to
        the required format.
      </Box>
    </Box>
    <Divider my={12} />
    <Box mb={4}>
      <Box
        as="h2"
        fontSize="24px"
        fontWeight="bold"
        color="text.darkBlue.900"
        mb={4}
        mt={8}
        fontFamily="marketingPage">
        Conclusion: Data Model Done Right, Insights Delivered Fast
      </Box>
      <Box mb={4}>
        Data standardization is no longer a bottleneck. With Yapamar,
        you&apos;ll get clean and unified datasets behind the scenes, so you can
        focus on what matters: insights and optimization outcomes.
      </Box>
    </Box>
  </Box>
);
